import { Button } from '@customerio/pluma-components/react';

type FiltersToggleButtonProps = {
  /** Whether the filter row is currently open (flips the label + clears on click). */
  showFilters: boolean;
  onClick: () => void;
};

export function FiltersToggleButton({ showFilters, onClick }: FiltersToggleButtonProps) {
  return (
    <Button variant="secondary" size="sm" icon="filter" onClick={onClick}>
      {showFilters ? 'Clear filters' : 'Add filters'}
    </Button>
  );
}
